// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fields-policies[data-v-09e3485a]{\n  margin-top: 1rem;\n}\n.policy-item .input-header[data-v-09e3485a]{\n  width: 60%;\n}\n\n", ""]);
// Exports
module.exports = exports;
